export default "__VITE_ASSET__BvgJTriy__"